import { Nullable } from "sonobello.utilities.react";

/** An update to the value of a medical form item. */
class MedicalFormItemState {
  /** The id of the form item from which the value update was issued. */
  readonly formId: string;
  /** The current value of the medical form item, or null if unset. */
  readonly value: Nullable<string>;

  constructor(formItemId: string, state: Nullable<string>) {
    this.formId = formItemId;
    this.value = state;
  }
}

export default MedicalFormItemState;
